const DigitalSettings = () => import('./_views/digitalSettings');

export default [
  {
    path: '/settings/digital',
    name: 'digitalSettings',
    component: DigitalSettings,
    meta: {
      title: 'Digital Settings',
      group: 'settings',
      navigation: {
        position: 2,
        name: 'Digital Settings',
        specialQueries: ['suffix'],
        to: {
          name: 'digitalSettings',
          query: {
            suffix: '',
          },
        },
      },
    },
  },
];
